import { Badge, Box, Button, Checkbox, InlineStack } from "@shopify/polaris";
import ShopifyModal from "../../../../../components/ShopifyModal";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from "../../../../../utils/utils"
// soucing次数不足弹窗
const Index = ({
  sourcingLimitModal,
  setSourcingLimitModal,
  subList,
  userPoints,
  handleSubmit,
  type,
  sourceLess,
  planShow,
  changeCancelSettingBtnState
}) => {
  
  const [selectId,setSelectId] = useState(0);
  const [isBulkSourcing,setIsBulkSourcing] = useState(false);
  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
  const router = useHistory();
  const formatNumber = (num) => {
    return parseFloat(num.toFixed(2)).toString();
  };
  useEffect(() => {
    let isMount = false;
    if (!isMount && sourcingLimitModal) {
      if (sourceLess && Object.values(sourceLess).length > 0) {
        let num = Number(sourceLess.sourceBulk.length * 200) > Number(userPoints.userPointsData.available_points);
        if (sourceLess?.user_product_id === '') {
          setIsBulkSourcing(true)
        }else {
          setIsBulkSourcing(false)
        }
        if (sourceLess?.user_product_id === '' && (plan_level.level === 0)) {
          setSelectId(1)
        }else if (sourceLess?.user_product_id === '' && num && (plan_level.level === 4)) {
          setSelectId(1)
        }else if (sourceLess?.user_product_id === '' && num && (plan_level.level === 1)) {
          setSelectId(2)
        }else if (sourceLess?.user_product_id === '' && num && (plan_level.level === 2)) {
          setSelectId(5)
        }else {
          setSelectId(0)
        }
      }else {
        if (type === 'auto_sourcing' || type === "auto_fulfillment" || type === "price_setting") {
          setSelectId(1)
        }else {
          setSelectId(0)
        }
      }
    }
    return () => {
      isMount = true;
    };
  }, [sourcingLimitModal,sourceLess,plan_level,userPoints,type])
  
  // sourcing 非会员、basic会员 展示升级套餐
  let isNotProMore = ()=>{
    let flag = false;
    if (sourceLess && sourceLess?.user_product_id ==='' && (plan_level.level === 0 || plan_level.level === 4)) {
      flag = true;
    }
    return flag;
  }
  const levelMap = {
    4: [1, 2, 5],
    1: [2, 5],
    2: [5],
    0: [1, 2, 4,5],
    5: []
  };
  // 对套餐展示进行限制
  const isValidChild = (level, childLevel) => {
    return levelMap[level]?.includes(childLevel) ?? false;
  };
  const ShowComponentFun = ()=>{
    let listData = !planShow ? subList.year : subList.month;
    let text = (<Box className="sourcing_enough_quota">
      <InlineStack wrap={false}>
        <Box className="sourcing_enough_quota_left">
          <Box>
            <img src="/new-product/source_product_upgrade.png" alt="sourcing" />
          </Box>
        </Box>
        <Box className="sourcing_enough_quota_right">
          <Box className="sourcing_enough_quota_title">
          {(isNotProMore()) ? 'Bulk sourcing requires the Pro package or above' : 'Sourcing request quota exceeded. Increase quota limit'}
          </Box>
          {(isNotProMore()) ? '': <Box className="sourcing_enough_quota_subtitle">
            Souring Benefits
          </Box>}
          {(isNotProMore()) ? <Box style={{marginBottom:'16px'}}>Select the sourcing plan that best suits your needs</Box>: <Box className="sourcing_enough_quota_subtitle_li">
            <ul>
              <li>
              Personalized Product Sourcing
              </li>
              <li>
              Competitive Pricing
              </li>
            </ul>
          </Box>}
          <Box className="sourcing_enough_quota_list">
            <InlineStack gap={200}>
              {listData.map((item,ind)=> (item.id !== 0 && isValidChild(plan_level.level,item.id)) && (
               <Box
               key={ind}
               className={
                 selectId === item.id
                   ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                   : "sourcing_enough_quota_item"
               }
             >
               <InlineStack
                 align="space-between"
                 blockAlign="center"
                 wrap={false}
               >
                 <Box className="sourcing_enough_quota_item_content">
                   <strong>{item.limitation.sourcing_num} Sourcing/{item.is_yearly ? "year" : "month"} </strong>
                   <Box>
                     <InlineStack wrap={false} blockAlign="center">
                       <p>
                        <span style={{ margin: "0 5px" }}>
                          {item.name} $
                          {formatNumber(
                            item.money * item.discount)}
                          /{item.is_yearly ? "year" : "month"}
                        </span>
                       </p>
                       {item.discount < 1 
                       ? (
                         <Badge tone="success">
                           {parseFloat(
                             (1 - item.discount) *
                               100
                           ).toFixed(0)}
                           % OFF
                         </Badge>
                       ) : (
                         ""
                       )}
                     </InlineStack>
                   </Box>
                 </Box>
                 <Box className="sourcing_enough_quota_item_checkbox">
                   <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                 </Box>
               </InlineStack>
             </Box>
             )
              )}
              {!isBulkSourcing && userPoints.userPointsData.available_points >= 200 ? (
                <Box className={
                    selectId === 6
                      ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                      : "sourcing_enough_quota_item"
                  }>
                  <InlineStack align="space-between" blockAlign="center">
                    <Box className="sourcing_enough_quota_item_content">
                    <InlineStack wrap={false} gap={200}>
                      <strong>1 Sourcing </strong>
                      <p>200 Points each sourcing</p>
                      </InlineStack>
                    </Box>
                    <Box className="sourcing_enough_quota_item_checkbox">
                      <Checkbox checked={selectId === 6}  onChange={()=>setSelectId(6)}/>
                    </Box>
                  </InlineStack>
                </Box>
              ) : (
                ""
              )}
            </InlineStack>
            
          </Box>
          <Box className="sourcing_enough_quota_item_link" onClick={()=>{
            // utils.routeListen('/admin/subscribe');
            utils.routeJump1(router,'/admin/subscribe')
          }}>
          Learn more about pricing
          </Box>
          <Box className="sourcing_enough_quota_item_button">
            <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{selectId === 6 || (plan_level.level === 5) ? "Redeem with Points" : "Upgrade Now"}</Button>
          </Box>
        </Box>
      </InlineStack>
    </Box>);

    if (type === 'sourcing') {
      text = (<Box className="sourcing_enough_quota">
        <InlineStack wrap={false}>
          <Box className="sourcing_enough_quota_left">
            <Box>
              <img src="/new-product/source_product_upgrade.png" alt="sourcing" />
            </Box>
          </Box>
          <Box className="sourcing_enough_quota_right">
            <Box className="sourcing_enough_quota_title">
            {(isNotProMore()) ? 'Bulk sourcing requires the Pro package or above' : 'Sourcing request quota exceeded. Increase quota limit'}
            </Box>
            {(isNotProMore()) ? '': <Box className="sourcing_enough_quota_subtitle">
              Souring Benefits
            </Box>}
            {(isNotProMore()) ? <Box style={{marginBottom:'16px'}}>Select the sourcing plan that best suits your needs</Box>: <Box className="sourcing_enough_quota_subtitle_li">
              <ul>
                <li>
                Personalized Product Sourcing
                </li>
                <li>
                Competitive Pricing
                </li>
              </ul>
            </Box>}
            <Box className="sourcing_enough_quota_list">
              {!isNotProMore() ? <InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !==0 && isValidChild(plan_level.level,item.id))  && (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     <strong>{item.limitation.sourcing_num} Sourcing/{item.is_yearly ? "year" : "month"} </strong>
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               item.discount *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
                {!isBulkSourcing && userPoints.userPointsData.available_points >= 200 ? (
                  <Box className={
                      selectId === 6
                        ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                        : "sourcing_enough_quota_item"
                    }>
                    <InlineStack align="space-between" blockAlign="center">
                      <Box className="sourcing_enough_quota_item_content">
                      <InlineStack wrap={false} gap={200}>
                        <strong>1 Sourcing </strong>
                        <p>200 Points each sourcing</p>
                        </InlineStack>
                      </Box>
                      <Box className="sourcing_enough_quota_item_checkbox">
                        <Checkbox checked={selectId === 6}  onChange={()=>setSelectId(6)}/>
                      </Box>
                    </InlineStack>
                  </Box>
                ) : (
                  ""
                )}
              </InlineStack>:<InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !==0 && isValidChild(plan_level.level,item.id) && item.id !== 4)  && (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     <strong>{item.limitation.sourcing_num} Sourcing/{item.is_yearly ? "year" : "month"} </strong>
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
                {!isBulkSourcing && userPoints.userPointsData.available_points >= 200 ? (
                  <Box className={
                      selectId === 6
                        ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                        : "sourcing_enough_quota_item"
                    }>
                    <InlineStack align="space-between" blockAlign="center">
                      <Box className="sourcing_enough_quota_item_content">
                      <InlineStack wrap={false} gap={200}>
                        <strong>1 Sourcing </strong>
                        <p>200 Points each sourcing</p>
                        </InlineStack>
                      </Box>
                      <Box className="sourcing_enough_quota_item_checkbox">
                        <Checkbox checked={selectId === 6}  onChange={()=>setSelectId(6)}/>
                      </Box>
                    </InlineStack>
                  </Box>
                ) : (
                  ""
                )}
              </InlineStack>}
              
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="sourcing_enough_quota_item_button">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{selectId === 6 || (plan_level.level === 5) ? "Redeem with Points" : "Upgrade Now"}</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    if (type === "product") {
      text = (<Box className="sourcing_enough_quota">
        <InlineStack wrap={false}>
        <Box className="sourcing_enough_quota_left">
            <Box>
                <img src="/new-product/add_product_upgrade.png" alt="sourcing" />
              </Box>
            </Box>
          <Box className="sourcing_enough_quota_right">
          <Box className="sourcing_enough_quota_title">
              Insufficient quota. Upgrade quota limit
              </Box>
            
            <Box className="sourcing_enough_quota_list">
              <InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !== 0 && isValidChild(plan_level.level,item.id)) && (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     <strong>{item.limitation.dsm_product_num} product/{item.is_yearly ? "year" : "month"} </strong>
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                              (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
                {userPoints.userPointsData.available_points >= 150 ? (
                    <Box className={
                        selectId === 6
                          ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                          : "sourcing_enough_quota_item"
                      }>
                      <InlineStack align="space-between" blockAlign="center">
                        <Box className="sourcing_enough_quota_item_content">
                        <InlineStack wrap={false} gap={200}>
                          <strong>1 Import </strong>
                          <p>150 Points each Import</p>
                          </InlineStack>
                        </Box>
                        <Box className="sourcing_enough_quota_item_checkbox">
                          <Checkbox checked={selectId === 6}  onChange={()=>setSelectId(6)}/>
                        </Box>
                      </InlineStack>
                    </Box>
                  ) : (
                    ""
                  )}
              </InlineStack>
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="sourcing_enough_quota_item_button">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{selectId === 6 || (plan_level.level === 5) ? "Redeem with Points" : "Upgrade Now"}</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    if (type === "aliexpress") {
      text = (<Box className="sourcing_enough_quota">
        <InlineStack wrap={false}>
        <Box className="sourcing_enough_quota_left">
            <Box>
                <img src="/new-product/ali_product_upgrade.png" alt="sourcing" />
              </Box>
            </Box>
            <Box className="sourcing_enough_quota_right">
              <Box className="sourcing_enough_quota_title">
              Insufficient quota. Upgrade quota limit
              </Box>
              <Box className="sourcing_enough_quota_subtitle">
              Import AliExpress product feature Benefits
              </Box>
              <Box className="sourcing_enough_quota_subtitle_li">
                <ul>
                  <li>
                  One-Click AliExpress Product Import
                  </li>
                  <li>
                  Complete AliExpress Data Collection
                  </li>
                </ul>
                
              </Box>
            <Box className="sourcing_enough_quota_list">
              <InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !== 0 && isValidChild(plan_level.level,item.id)) &&(
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     <strong>{item.limitation.ali_product_num} product/{item.is_yearly ? "year" : "month"} </strong>
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
                {userPoints.userPointsData.available_points >= 150 ? (
                    <Box className={
                        selectId === 6
                          ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                          : "sourcing_enough_quota_item"
                      }>
                      <InlineStack align="space-between" blockAlign="center">
                        <Box className="sourcing_enough_quota_item_content">
                        <InlineStack wrap={false} gap={200}>
                          <strong>1 Import </strong>
                          <p>150 Points each Import</p>
                          </InlineStack>
                        </Box>
                        <Box className="sourcing_enough_quota_item_checkbox">
                          <Checkbox checked={selectId === 6}  onChange={()=>setSelectId(6)}/>
                        </Box>
                      </InlineStack>
                    </Box>
                  ) : (
                    ""
                  )}
              </InlineStack>
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="sourcing_enough_quota_item_button">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{selectId === 6 || (plan_level.level === 5) ? "Redeem with Points" : "Upgrade Now"}</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    if (type === "auto_sourcing")  {
      text = (<Box className="sourcing_enough_quota">
        <InlineStack wrap={false}>
          <Box className="sourcing_enough_quota_left">
            <Box>
              <img src="/new-product/source_product_upgrade.png" alt="sourcing" />
            </Box>
          </Box>
          <Box className="sourcing_enough_quota_right">
            
            <Box className="sourcing_enough_quota_subtitle">
            Auto Sourcing Benefits
            </Box>
            <Box className="sourcing_enough_quota_subtitle_li">
              <ul>
                <li>
                Auto-initiate sourcing
                </li>
                <li>
                Streamline order fulfillment
                </li>
              </ul>
            </Box>
            <Box className="sourcing_enough_quota_list">
              <InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !==0 && isValidChild(plan_level.level,item.id) && item.id !== 4)  &&  (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     {/* <strong>{item.limitation.sourcing_num} Sourcing/month </strong> */}
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
              </InlineStack>
              
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="sourcing_enough_quota_item_button">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{"Upgrade Now"}</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    if (type === "auto_fulfillment")  {
      text = (<Box className="sourcing_enough_quota">
        <InlineStack wrap={false}>
          <Box className="sourcing_enough_quota_left">
            <Box>
              <img src="/order_fulfillment/fulfillment_quota_bg.png" alt="sourcing" />
            </Box>
          </Box>
          <Box className="sourcing_enough_quota_right">
            
            <Box className="sourcing_enough_quota_subtitle">
            Auto Fulfillment Benefits
            </Box>
            <Box className="sourcing_enough_quota_subtitle_li">
              <ul>
                <li>
                Auto Order Payment
                </li>
                <li>
                Efficient Order Fulfillment
                </li>
              </ul>
            </Box>
            <Box className="sourcing_enough_quota_list">
              <InlineStack gap={200}>
                {listData.map((item,ind)=> (item.id !==0 && isValidChild(plan_level.level,item.id)&& item.id !== 4)  &&  (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     {/* <strong>{item.limitation.sourcing_num} Sourcing/month </strong> */}
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
              </InlineStack>
              
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="sourcing_enough_quota_item_button">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{"Upgrade Now"}</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    if (type === "price_setting") {
      text = (<Box className="sourcing_enough_quota">
        
        <InlineStack wrap={false}>
          <Box className="sourcing_enough_quota_left">
            <Box>
            <img src="/order_fulfillment/price_quota_bg.png" alt="price" />
            </Box>
          </Box>
          <Box className="sourcing_enough_quota_right sourcing_enough_quota_right_small">
          <Box className="sourcing_enough_quota_left_small">
            <img src="/order_fulfillment/fulfillment_quota_small.png" alt="sourcing" />
            </Box>
          <Box className="sourcing_enough_quota_title">
          Unlock smart pricing with our advanced plan
              </Box>
            <Box className="sourcing_enough_quota_subtitle">
            Benefits
            </Box>
            <Box className="sourcing_enough_quota_subtitle_li">
              <ul>
                <li>
                Tired pricing
                </li>
                <li>
                Custom markup rules
                </li>
                <li>
                Psychological pricing
                </li>
              </ul>
            </Box>
            <Box className="sourcing_enough_quota_list">
              <InlineStack gap={200}>
              {listData.map((item,ind)=> (item.id !==0 && isValidChild(plan_level.level,item.id)&& item.id !== 4)  &&  (
                 <Box
                 key={ind}
                 className={
                   selectId === item.id
                     ? "sourcing_enough_quota_item sourcing_enough_quota_item_active"
                     : "sourcing_enough_quota_item"
                 }
               >
                 <InlineStack
                   align="space-between"
                   blockAlign="center"
                   wrap={false}
                 >
                   <Box className="sourcing_enough_quota_item_content">
                     {/* <strong>{item.limitation.sourcing_num} Sourcing/month </strong> */}
                     <Box>
                       <InlineStack wrap={false} blockAlign="center">
                         <p>
                          <span style={{ margin: "0 5px" }}>
                            {item.name} $
                            {formatNumber(
                              item.money * item.discount)}
                            /{item.is_yearly ? "year" : "month"}
                          </span>
                         </p>
                         {item.discount < 1 
                         ? (
                           <Badge tone="success">
                             {parseFloat(
                               (1 - item.discount) *
                                 100
                             ).toFixed(0)}
                             % OFF
                           </Badge>
                         ) : (
                           ""
                         )}
                       </InlineStack>
                     </Box>
                   </Box>
                   <Box className="sourcing_enough_quota_item_checkbox">
                     <Checkbox checked={selectId === item.id}  onChange={()=>setSelectId(item.id)}/>
                   </Box>
                 </InlineStack>
               </Box>
               )
                )}
              </InlineStack>
              
            </Box>
            <Box className="sourcing_enough_quota_item_link" onClick={()=>{
              // utils.routeListen('/admin/subscribe');
              utils.routeJump1(router,'/admin/subscribe')
            }}>
            Learn more about pricing
            </Box>
            <Box className="setting_price_btn_line"></Box>
            <Box className="sourcing_enough_quota_item_button setting_price_btn">
              <Button variant="primary" onClick={()=>handleSubmit(selectId)}>{"Happy upgrade"}</Button>
            </Box>
            <Box className="sourcing_enough_quota_item_button setting_price_btn setting_price_btn_cancel">
              <Button onClick={()=>setSourcingLimitModal(false)}>Cancel</Button>
            </Box>
          </Box>
        </InlineStack>
      </Box>)
    }
    return text;
  }

  return (
    <Box>
      <ShopifyModal id="enough-quota-modal"
        open={sourcingLimitModal}
        onClose={() => {
          setSourcingLimitModal(false);
          if (changeCancelSettingBtnState) {
            changeCancelSettingBtnState()
          }
        }}
      >
      {ShowComponentFun()}
      </ShopifyModal>
    </Box>
  );
};

export default Index;
